import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  Button,
  Form,
  Row,
  Col,
  Container,
  Table,
  Modal,
  Card,
  Image,
  Collapse,
  InputGroup,
  OverlayTrigger,
  Tooltip
} from "react-bootstrap";
import { db } from "../db/firestore";
import { daysDifference, formatTime } from "../Utility/function";
import { NumberYMD, stringDateTime3 } from "../Utility/dateTime";
import { colors } from "../configs";
import { Modal_Package } from "../modal";

const { redSanta } = colors;


function PackageScreen() {
    const { shop:{ vip } } = useSelector(state=>state.shop);

    const [detail, setDetail] = useState({ display:[], admin:[], payment:[] });
    const { display, admin, payment } = detail;
    const [loading, setLoading] = useState(false);
    

    useEffect(()=>{
        fetchDetail()
    },[]);

    async function fetchDetail(){
        setLoading(true)
        try {
            const detailDoc = await db.collection('admin').doc('package').get();
            if(detailDoc.exists){
                const { value, admin, payment } = detailDoc.data();
                setDetail({
                    display:value.filter(a=>a.status),
                    admin,
                    payment
                })
            }
        } catch (error) {
            console.log(error)
        } finally {
            setLoading(false)
        }
    };

    const [package_Modal, setPackage_Modal] = useState(false);
  return (
    <div style={{ minHeight:'100vh' }}>
        <Modal_Package
            show={package_Modal}
            onHide={()=>{setPackage_Modal(false)}}
            display={display}
            admin={admin}
            payment={payment}
        />
      <h1>แพ็กเกจของฉัน</h1>
      <Button variant="warning" style={{ width:'30%',
    borderRadius:20,
    marginTop:10,
    paddingTop:30,
    paddingBottom:30, 
    marginBottom:10}} onClick={()=>{setPackage_Modal(true)}} >
        <h3>+ เติมแพ็กเกจ</h3>
    </Button>
      <div style={{ display: 'flex', flexWrap: 'wrap' }}>
      {display.map((item, index) => {
        let text = '-- หมดอายุ --';
        const findVIP = vip.find((a) => a.type === item.type);
        let color = redSanta;
        const today = NumberYMD(new Date());

        if (findVIP && findVIP.type) {
          const expireDate = formatTime(findVIP.expire);
          if (today < NumberYMD(expireDate)) {
            text = `${stringDateTime3(expireDate)}`;
          }
          const diff = Math.ceil(daysDifference(expireDate, new Date()));
          if (diff > 30) {
            color = '#00BF63';
          }
        }

        return (
          <div key={index} style={{ margin: 10, textAlign: 'center' }}>
            <img src={item.imageId} alt={item.name} style={{ width: 100, height: 100, objectFit: 'cover' }} />
            <div style={{ fontWeight: 'bold' }}>{item.name}</div>
            <div style={{ width: 120, color, fontWeight: 'bold' }}>{text}</div>
          </div>
        );
      })}
    </div>
    </div>
  );
}

export default PackageScreen;